import { Action, createReducer, on } from '@ngrx/store';
import { hydrateFailure, hydrateSuccess } from '../actions/hydration.actions';
import { CacheInfoState, initialCacheInfoState } from '../types/cache-info.state';

const hydratationCompleteReducer = (state: CacheInfoState): CacheInfoState => {
    return {
        ...state,
        rehydrated: true,
    };
};

const createCacheInfoReducer = createReducer(
    initialCacheInfoState,
    on(hydrateFailure, hydratationCompleteReducer),
    on(hydrateSuccess, hydratationCompleteReducer),
);

export function cacheInfoReducer(state: Readonly<CacheInfoState>, action: Action): Readonly<CacheInfoState> {
    return createCacheInfoReducer(state, action);
}
